import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import useIntegrityProfGralSpac from '../hooks/useIntegrityProfGralSpac';

const IntegrityProfGralSpac = (props: any) => {
  const loadProfSpac = useIntegrityProfGralSpac(props.data.key);

  return (
    <IntegrityRoleGrid
      dataSource={loadProfSpac}
      disabledExport={true}
      autoWidth={false}
      id={['revision']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
    >
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('Nombre del Spac')} dataField="spac_Name" />
      <Column caption={i18n2._('SPAC')} dataField="spac" />
      <Column
        caption={i18n2._('Descripcion del perfil-spac')}
        defaultSortOrder={'asc'}
        dataField="profileDesc"
        width={200}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default IntegrityProfGralSpac;
